import React, { useState } from "react";
import { FontAwesomeIcon } from '@fortawesome/react-fontawesome'
import { faAngleDown, faAngleRight } from '@fortawesome/free-solid-svg-icons'
const Dropdown = ({ title, items }) => {
  const [isOpen, setIsOpen] = useState(false);

  const toggleDropdown = () => {
    setIsOpen(!isOpen);
  };

  return (
    <div className="dropdown">
      <h3 className={`subtitle ${isOpen ? "open" : ""}`}  onClick={toggleDropdown} style={{ cursor: "pointer", display: "flex", alignItems: "center" }} >
        {title}
        <FontAwesomeIcon icon={isOpen ? faAngleDown : faAngleRight} />
      </h3>
      <div 
        className={`services-inner ${isOpen ? "visible" : "hidden"}`}
        style={{ overflow: "hidden", transition: "max-height 0.3s ease" }}>
        {items.map((item, index) => (
          <div className="services-box" key={index}>
            <span className="icon">
              <p>{item.sigla}</p>
            </span>
            <h3 className="services-title">{item.nome}</h3>
          </div>
        ))}
      </div>
    </div>
  );
};

export default Dropdown;